// eslint-disable-next-line import/prefer-default-export
export const contactOperatorString = client => {
    const supportDetails = client && client.support ? client.support : null;

    if (!(supportDetails && supportDetails.name)) {
        return 'your transport provider directly';
    }

    let contactString = supportDetails.name;

    if (supportDetails.email) {
        contactString += ` at ${supportDetails.email}`;
        if (supportDetails.phone) {
            contactString += ` or on ${supportDetails.phone}`;
        }
    } else if (supportDetails.phone) {
        contactString += ` on ${supportDetails.phone}`;
    }

    return contactString;
};
